export default "__VITE_ASSET__yg3uoNV$__"